import { render } from "./AdminQueries.vue?vue&type=template&id=51f89aee&scoped=true"
import script from "./AdminQueries.vue?vue&type=script&lang=js"
export * from "./AdminQueries.vue?vue&type=script&lang=js"

import "./AdminQueries.vue?vue&type=style&index=0&id=51f89aee&scoped=true&lang=css"
import "./AdminQueries.vue?vue&type=style&index=1&id=51f89aee&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f89aee"]])

export default __exports__